import _objectSpread from "/codebuild/output/src1081057209/src/api-desk/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/codebuild/output/src1081057209/src/api-desk/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _ from 'lodash';
import { find_matching_feed_definition } from './fdef_utils';
var profileEditor = null;
var current_before = null;
var current_au = null;
var triggerProfileEditFinished = null;
export function aufschaltung_grouped_by_profile(aufschaltung) {
  //console.log('###', aufschaltung)
  if (!aufschaltung) {
    return [];
  }

  var feeds = aufschaltung.feeds || []; // remove profile_summary of feed

  _.forEach(feeds, function (f) {
    return delete f.profile_summary;
  });

  var viewspecs = aufschaltung.viewspecs || [];
  viewspecs.map(function (entry, i) {
    // Convert nested JSON-String entries to Object (AWSJSON not able to deliver this)
    if (_.isString(entry.feed_options)) {
      entry.feed_options = JSON.parse(entry.feed_options);
    }

    if (_.isString(entry.media_group_contents_options)) {
      entry.media_group_contents_options = JSON.parse(entry.media_group_contents_options);
    }

    return entry;
  });
  var feed_definitions = get_feed_defintion_from_au(aufschaltung);
  var apis = aufschaltung.apis || [];
  var profiles = aufschaltung.profiles || [];
  var groups = [];

  _.forEach(_.groupBy(feeds, function (f) {
    return f.profile_id;
  }), function (group_feeds, profile_id) {
    var group_profile = profiles ? profiles.filter(function (p) {
      return p.id === profile_id;
    }) : [];

    if (group_profile) {
      var nickname = group_profile[0].nickname;
      var group_viewspecs = viewspecs ? viewspecs.filter(function (viewspec) {
        return group_feeds.find(function (f) {
          return f.viewspec_id === viewspec.id;
        });
      }) : [];
      var group_apis = apis ? apis.filter(function (api) {
        return group_feeds.find(function (f) {
          return f.api_kind === api.kind;
        });
      }) : [];
      var group_fdefs = feed_definitions ? find_matching_feed_definition({
        group_feeds: group_feeds,
        group_profile: group_profile,
        group_apis: group_apis,
        group_viewspecs: group_viewspecs,
        feed_definitions: feed_definitions
      }).match : []; // cf3api format

      var partial = {
        feeds: group_feeds,
        profiles: group_profile,
        viewspecs: group_viewspecs,
        apis: group_apis,
        feed_definitions: group_fdefs //console.log('----', {profile_id, nickname, aufschaltung: partial})

      };
      groups.push({
        profile_id: profile_id,
        nickname: nickname,
        aufschaltung: partial
      });
    }
  });

  return groups;
}
export function viewspecs_to_json(viewspecs) {
  return viewspecs.map(function (vs) {
    return {
      'id': vs.id,
      'feed_options': vs.feed_options ? JSON.stringify(vs.feed_options) : null,
      'content_options': vs.content_options ? JSON.stringify(vs.content_options) : null,
      'media_group_contents_options': vs.media_group_contents_options ? JSON.stringify(vs.media_group_contents_options) : null,
      'media_groups_options': vs.media_groups_options ? JSON.stringify(vs.media_groups_options) : null,
      'category_options': vs.category_options ? JSON.stringify(vs.category_options) : null
    };
  });
}
/**
 * Merge changes into original Aufschaltung
 * 
 * @param {object} aufschaltung The original Aufschaltung object
 * @param {object} before       The grouped object with one profile before changes
 * @param {object} after        The grouped object with one profile after changes
 * @returns {object}            The Aufschaltung with changes
 */

export function merge_aufschaltung_changes(au, before, after) {
  // 1. new profile if (before === undefined)
  // 2. existing profile edited - keep ids
  // Current aufschaltungs properties
  var old_apis = au.apis || [];
  var old_feeds = au.feeds || [];
  var old_profiles = au.profiles || [];
  var old_viewspecs = au.viewspecs || [];
  var old_feed_definitions = get_feed_defintion_from_au(au); // New profile or existing profile changes

  var new_apis = after.apis || [];
  var new_feeds = after.feeds || [];
  var new_profiles = after.profiles || [];
  var new_viewspecs = after.viewspecs || [];
  var new_feed_definitions = after.feed_definitions || [];
  var merged_apis;
  var merged_profiles;
  var merged_feeds;
  var merged_viewspecs;
  var merged_feed_defs;

  if (before === undefined) {
    merged_apis = basic_merge(old_apis, new_apis);
    merged_profiles = [].concat(_toConsumableArray(old_profiles), _toConsumableArray(new_profiles));
    merged_feeds = [].concat(_toConsumableArray(old_feeds), _toConsumableArray(new_feeds));
    merged_viewspecs = [].concat(_toConsumableArray(old_viewspecs), _toConsumableArray(new_viewspecs));
    merged_feed_defs = [].concat(_toConsumableArray(old_feed_definitions), _toConsumableArray(new_feed_definitions));
  } else {
    // Merge apis
    merged_apis = basic_merge(old_apis, new_apis); // Merge profiles

    merged_profiles = basic_merge(old_profiles, new_profiles); // Merge feeds

    merged_feeds = basic_merge(old_feeds, new_feeds); // Merge viewspecs

    merged_viewspecs = basic_merge(old_viewspecs, new_viewspecs); // Merge feed_defintions
    //merged_feed_defs = old_feed_definitions

    var group_feeds = before.feeds || [];
    var group_profile = before.profiles || [];
    var group_apis = before.apis || [];
    var group_viewspecs = before.viewspecs || [];
    merged_feed_defs = merge_feed_definitions({
      old_feed_definitions: old_feed_definitions,
      new_feed_definitions: new_feed_definitions,
      group_feeds: group_feeds,
      group_profile: group_profile,
      group_apis: group_apis,
      group_viewspecs: group_viewspecs
    });
  }

  var merged_au = au;
  merged_au.apis = merged_apis;
  merged_au.feeds = merged_feeds;
  merged_au.profiles = merged_profiles;
  merged_au.viewspecs = viewspecs_to_json(merged_viewspecs);
  merged_au.feed_definitions = JSON.stringify(merged_feed_defs);
  merged_au.profed_changes = true;
  return merged_au;
}
export function openProfileEditor(event, auth0_context, aufschaltung, id, default_profile, onProfileEditFinished) {
  event.stopPropagation();
  var found_au_with_profile = aufschaltung_grouped_by_profile(aufschaltung).find(function (p) {
    return p.profile_id === id;
  });
  current_before = found_au_with_profile && found_au_with_profile.aufschaltung;
  current_au = aufschaltung; //console.log('current_before', current_au, current_before)

  triggerProfileEditFinished = onProfileEditFinished;
  var json_data = {
    au: current_before,
    atoken: auth0_context.access_token,
    default_profile: default_profile //au = aufschaltung

  };
  var data = btoa(JSON.stringify(json_data, null, 0));
  var PROFILE_EDITOR_URL = process.env.REACT_APP_PROFILE_EDITOR_URL;
  var externalUrl = "".concat(PROFILE_EDITOR_URL, "/index.html#data=").concat(data);

  if (profileEditor) {
    profileEditor.close();
    window.removeEventListener('message', profileEditorClosed, false);
  }

  profileEditor = window.open(externalUrl, 'Profile Editor');
  window.addEventListener('message', profileEditorClosed, false);
}

function profileEditorClosed(event) {
  var after = event.data;

  if (after === '') {
    console.log('canceled');
  } else {
    after = after.replace('#data=', '');
    after = JSON.parse(atob(after)); // Merge old and new

    var merged_au = merge_aufschaltung_changes(current_au, current_before, after.au); // Prepare partial for gql-schema

    var partial_au = after.au;
    partial_au.auid = current_au.auid;
    partial_au.viewspecs = viewspecs_to_json(partial_au.viewspecs || []);
    partial_au.feed_definitions = merged_au.feed_definitions;
    partial_au.profed_changes = true; // trigger finished method
    //console.log('AFTER merged_au', merged_au)

    triggerProfileEditFinished({
      complete_au: merged_au,
      partial_au: after.au
    });
  }
}

export function basic_merge(old_arr, new_arr) {
  return old_arr.map(function (o) {
    return _objectSpread({}, o, new_arr.find(function (n) {
      return n.id === o.id;
    }));
  });
}
export function merge_feed_definitions(_ref) {
  var old_feed_definitions = _ref.old_feed_definitions,
      new_feed_definitions = _ref.new_feed_definitions,
      group_feeds = _ref.group_feeds,
      group_profile = _ref.group_profile,
      group_apis = _ref.group_apis,
      group_viewspecs = _ref.group_viewspecs;
  if (!old_feed_definitions || !new_feed_definitions) return null;
  var merged_feed_defs;

  if (old_feed_definitions.length === 1) {
    // All new feed_definitions are fine
    merged_feed_defs = new_feed_definitions;
  } else {
    // Find feed_defintion entry which needs to be updated
    var _find_matching_feed_d = find_matching_feed_definition({
      group_feeds: group_feeds,
      group_profile: group_profile,
      group_apis: group_apis,
      group_viewspecs: group_viewspecs,
      feed_definitions: old_feed_definitions
    }),
        match = _find_matching_feed_d.match,
        origin_index = _find_matching_feed_d.origin_index;

    merged_feed_defs = old_feed_definitions;
    merged_feed_defs[origin_index] = new_feed_definitions[0];
  }

  return merged_feed_defs;
}
export function get_feed_defintion_from_au(aufschaltung) {
  if (!aufschaltung) return [];
  var feed_definitions = aufschaltung.feed_definitions || null; // Convert JSON-String to Object

  if (feed_definitions) {
    if (typeof feed_definitions === 'string') {
      feed_definitions = JSON.parse(feed_definitions);
    } else {
      feed_definitions = feed_definitions;
    }
  } else {
    feed_definitions = [];
  }

  return feed_definitions;
}